<template>
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.5897 19.1769H0.411717C0.184752 19.1769 0.00012207 19.3603 0.00012207 19.5885C0.00012207 19.8166 0.184752 20 0.411717 20H19.5897C19.8167 20 20.0013 19.8166 20.0013 19.5885C20.0013 19.3603 19.8178 19.1769 19.5897 19.1769Z"
      :fill="iconColor"
    />
    <path
      d="M5.61781 3.41583L9.58911 1.12411V16.3889C9.58911 16.6159 9.77374 16.8005 10.0007 16.8005C10.2277 16.8005 10.4123 16.6171 10.4123 16.3889V1.12411L14.3836 3.41583C14.4483 3.45346 14.5188 3.4711 14.5894 3.4711C14.7317 3.4711 14.8693 3.39702 14.9457 3.26533C15.0598 3.06896 14.9928 2.81733 14.7952 2.70327L10.2065 0.0552648C10.2006 0.0517372 10.1936 0.0529131 10.1865 0.0493856C10.1301 0.0211652 10.0689 0 10.0007 0C9.9325 0 9.87135 0.0211652 9.81373 0.0493856C9.80785 0.0529131 9.80079 0.0517372 9.79491 0.0552648L5.20621 2.70327C5.00982 2.81733 4.94161 3.06778 5.05569 3.26533C5.16976 3.46169 5.41906 3.52872 5.61781 3.41583Z"
      :fill="iconColor"
    />
  </svg>
</template>

<script>
export default {
  name: "IconUpload",
  data: () => ({
    iconColor: "currentColor",
  }),
};
</script>
